import { ProfanityCheckRule } from '@/types/profanity'
import axios from './orderInstance'

// Creates the selected company's profanity policy (one policy per company).
const createProfanityCheckRule = async (rule: ProfanityCheckRule) => {
  const response = await axios.post('/profanity-check-rules/', rule)
  return response.data
}

export default createProfanityCheckRule
